var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPickPrintPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6701_2199)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6701_2199",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H60V60H0V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6701_2199)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6701_2199",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 57,
    height: 57
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H59V59H2V2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6701_2199)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.667 2H8.333C6.65329 2.00027 5.04247 2.66771 3.85483 3.85554C2.66719 5.04337 2 6.65429 2 8.334L2 52.667C2 54.3466 2.66722 55.9574 3.85489 57.1451C5.04256 58.3328 6.65338 59 8.333 59H17.833C19.5126 59 21.1234 58.3328 22.3111 57.1451C23.4988 55.9574 24.166 54.3466 24.166 52.667V47.917C24.166 47.4972 24.3328 47.0945 24.6297 46.7976C24.9265 46.5008 25.3292 46.334 25.749 46.334H52.667C53.4987 46.334 54.3223 46.1702 55.0908 45.8518C55.8592 45.5335 56.5574 45.0669 57.1455 44.4788C57.7335 43.8906 58.2 43.1923 58.5182 42.4238C58.8364 41.6554 59.0001 40.8317 59 40V8.334C59 6.65429 58.3328 5.04337 57.1452 3.85554C55.9575 2.66771 54.3467 2.00027 52.667 2ZM57.417 40C57.4157 41.2594 56.9148 42.4668 56.0243 43.3573C55.1338 44.2478 53.9264 44.7487 52.667 44.75H25.75C24.9107 44.7511 24.106 45.085 23.5125 45.6785C22.919 46.272 22.5851 47.0766 22.584 47.916V52.666C22.5827 53.9252 22.0819 55.1325 21.1916 56.0229C20.3014 56.9134 19.0942 57.4144 17.835 57.416H8.335C7.0758 57.4144 5.86865 56.9134 4.97835 56.0229C4.08806 55.1325 3.58732 53.9252 3.586 52.666V8.334C3.58732 7.0748 4.08806 5.86754 4.97835 4.97706C5.86865 4.08658 7.0758 3.58559 8.335 3.584H52.667C53.9264 3.58532 55.1338 4.08619 56.0243 4.9767C56.9148 5.86722 57.4157 7.07463 57.417 8.334V40Z",
    fill: "#1A1818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2443 12.5142V12.5032C32.0528 12.2161 31.7932 11.9808 31.4886 11.8184C31.184 11.6561 30.844 11.5717 30.4988 11.5728C30.1537 11.5739 29.8142 11.6604 29.5106 11.8247C29.2071 11.989 28.949 12.2259 28.7593 12.5142C27.1723 15.3552 21.9793 24.7192 21.7593 25.9552C21.4029 27.3687 21.4058 28.8488 21.7679 30.2608C22.13 31.6728 22.8397 32.9717 23.8323 34.0392C24.674 34.9314 25.6913 35.6396 26.8201 36.1194C27.9489 36.5993 29.1648 36.8402 30.3913 36.8272H30.6003C31.8357 36.8402 33.0603 36.5963 34.1964 36.111C35.3326 35.6258 36.3555 34.9097 37.2003 34.0082C38.1832 32.9462 38.8851 31.6552 39.2421 30.2528C39.599 28.8504 39.5998 27.381 39.2443 25.9782C39.0243 24.7202 33.8313 15.3552 32.2443 12.5142ZM36.0063 32.9672C35.3085 33.7015 34.4658 34.2829 33.5316 34.6747C32.5975 35.0665 31.5921 35.2601 30.5793 35.2432H30.4913C29.46 35.265 28.4357 35.0709 27.4838 34.6734C26.532 34.276 25.6738 33.6839 24.9643 32.9352C24.1509 32.05 23.5732 30.9744 23.2845 29.8074C22.9959 28.6404 23.0054 27.4196 23.3123 26.2572C23.4993 25.4312 26.9683 18.9572 30.1313 13.2962C30.1713 13.2352 30.2259 13.185 30.2902 13.1503C30.3544 13.1156 30.4263 13.0974 30.4993 13.0974C30.5723 13.0974 30.6442 13.1156 30.7084 13.1503C30.7727 13.185 30.8273 13.2352 30.8673 13.2962C34.0343 18.9662 37.5013 25.4342 37.7093 26.3522C38.002 27.5095 37.9997 28.7217 37.7027 29.8779C37.4057 31.0341 36.8235 32.0973 36.0093 32.9702",
    fill: "#1A1818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8689 24.2841C33.8484 24.2484 33.8189 24.2187 33.7832 24.198C33.7476 24.1774 33.7071 24.1665 33.6659 24.1665C33.6247 24.1665 33.5843 24.1774 33.5486 24.198C33.513 24.2187 33.4834 24.2484 33.4629 24.2841C33.4629 24.2841 32.1719 26.7691 32.1309 27.0071C32.0668 27.2544 32.0657 27.5138 32.1279 27.7616C32.1901 28.0093 32.3136 28.2375 32.4869 28.4251C32.6353 28.5836 32.8151 28.7095 33.0148 28.7945C33.2146 28.8796 33.4299 28.922 33.6469 28.9191H33.6829C33.9 28.922 34.1153 28.8796 34.3151 28.7945C34.5148 28.7095 34.6946 28.5836 34.8429 28.4251C35.0163 28.2375 35.1397 28.0093 35.2019 27.7616C35.2641 27.5138 35.2631 27.2544 35.1989 27.0071C35.1579 26.7711 33.8669 24.2861 33.8669 24.2861",
    fill: "#1A1818"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6701_2199"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickPrintPlan);
export default __webpack_public_path__ + "static/media/pick-print-plan.a6ddb173d8f4ad1ef6ee49585f90a46e.svg";
export { ForwardRef as ReactComponent };